var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("f7-page", [
    _c("div", { staticStyle: { padding: "15px" } }, [_c("payment-lmsg")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }